import { render, staticRenderFns } from "./SubMenuItem.vue?vue&type=template&id=14fed4cd&scoped=true"
import script from "./SubMenuItem.vue?vue&type=script&lang=js"
export * from "./SubMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SubMenuItem.vue?vue&type=style&index=0&id=14fed4cd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fed4cd",
  null
  
)

export default component.exports